import { CalendarSettingsType } from '../calendar-types';

const SECONDS_IN_HOUR = 60 * 60;

export function getSecondsInPixel(settings: Partial<CalendarSettingsType>) {
  const { stepWidth = 100 } = settings;
  return SECONDS_IN_HOUR / stepWidth;
}
